import { styled } from "@mui/material/styles";
import { Box, Container, ContainerProps } from "@mui/material";

import { drawerWidth } from "../main-menu";

export const StyledRoot = styled(Box)({
  display: "flex",
  height: "100vh",
  position: "relative",
});

export interface IStyledContainerProps extends ContainerProps {
  isDashboard?: boolean;
  isProfile?: boolean;
  isMenuOpen?: boolean;
  onlyPage?: boolean;
  menuDrawerWidth?: number;
}

export const StyledContainer = styled(Container, {
  shouldForwardProp: prop =>
    prop !== "isDashboard" &&
    prop !== "isProfile" &&
    prop !== "isMenuOpen" &&
    prop !== "onlyPage" &&
    prop !== "menuDrawerWidth",
})<IStyledContainerProps>(({ isDashboard, isProfile, isMenuOpen, onlyPage, menuDrawerWidth = drawerWidth, theme }) => ({
  margin: onlyPage || isDashboard || isProfile ? 0 : "auto",
  paddingTop: onlyPage ? 0 : theme.spacing(11),
  paddingBottom: isProfile ? 0 : theme.spacing(1),
  paddingLeft: isProfile ? theme.spacing(2) : undefined,
  paddingRight: isProfile ? theme.spacing(2) : undefined,
  width: !onlyPage && isMenuOpen ? `calc(100% - ${menuDrawerWidth}px)` : "100%",
  display: "flex",
  flexDirection: "column",
  flex: 1,

  ...(isDashboard || onlyPage
    ? {
        height: "100%",
        overflow: "hidden",
      }
    : isProfile
      ? {
          minHeight: 0,
          height: "100%",
          overflow: "hidden",
        }
      : {
          minHeight: 0,
          height: "auto",
          overflow: "visible",
        }),

  [theme.breakpoints.down("sm")]: {
    width: "100%",
  },
}));
